import './global'
import './contact_us'
import './introduction'

let eventBinding = () => {
  $('.header .nav').on('click', 'a', (e) => {
    let el = e.currentTarget
    if (
      location.pathname.replace(/^\//,'') == el.pathname.replace(/^\//,'') && 
      location.hostname == el.hostname
    ) {
      e.preventDefault()
      let $target = $($(el).attr('hash'))
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top
        }, 1000)
        return false
      }
    }
  })
}

eventBinding()



/** WEBPACK FOOTER **
 ** assets/javascripts/index.js
 **/